import { useEffect, useState } from "react";
import { MessageCircle, Phone } from "lucide-react";
import { CONTACT, waLink } from "../../lib/site";

export const FloatingButtons = () => {
  const [show, setShow] = useState(false);
  useEffect(() => {
    const onScroll = () => setShow(window.scrollY > 500);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <div className={`fixed bottom-5 right-5 z-50 flex flex-col gap-3 transition-all duration-300 ${show ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6 pointer-events-none"}`}>
      <a href={`tel:${CONTACT.phonePrimary.tel}`} data-testid="float-call-btn" aria-label="Chiama"
        className="w-14 h-14 rounded-full bg-ink text-white flex items-center justify-center shadow-xl hover:scale-110 transition-transform">
        <Phone className="w-6 h-6" />
      </a>
      <a href={waLink()} target="_blank" rel="noreferrer" data-testid="float-whatsapp-btn" aria-label="WhatsApp"
        className="w-14 h-14 rounded-full bg-[#25D366] text-white flex items-center justify-center shadow-xl hover:scale-110 transition-transform animate-softpulse">
        <MessageCircle className="w-7 h-7" />
      </a>
    </div>
  );
};
